import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, InputModule, SelectModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AffectedItemsFormGroup, ProductDamageDomesticFormGroup } from '../../../models/cod-create.model';
import { OrderLineTableComponent } from '../../../../shared/components/order-line-table/order-line-table.component';
import { DamageIssueType, IOrderLine } from '@cod-monorepo/interfaces';
import { ItemType } from '@cod-monorepo/interfaces';
import { tap } from 'rxjs';

@Component({
    selector: 'app-cod-affected-items-damage-domestic-step',
    templateUrl: './affected-items-damage-domestic.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        OrderLineTableComponent
    ],
    standalone: true
})
export class CodAffectedItemsDamageDomesticStepComponent implements OnInit {
    @Input({ required: true })
    affectedItemsForm: FormGroup<AffectedItemsFormGroup>;
    @Input({ required: true }) form: FormGroup<ProductDamageDomesticFormGroup>;

    public damageTypes = DamageIssueType;
    public itemTypes = ItemType;
    public showError = false;

    ngOnInit(): void {
        this.initItemTypeChangeListener();
    }

    public get confirmed(): boolean {
        return this.affectedItemsForm.controls.confirmed.value ?? false;
    }

    public get lineItems(): IOrderLine[] {
        return this.affectedItemsForm.controls.affectedOrderLines.value ?? [];
    }

    public get disabled(): boolean {
        return this.affectedItemsForm.disabled;
    }

    public get valid(): boolean {
        const orderLinesSelected = (this.affectedItemsForm.controls.affectedOrderLines.value ?? []).length > 0;
        const damageTypeSelected = !!this.form.controls.damageType.value;
        const itemTypeSelected = !!this.form.controls.itemType.value;
        return orderLinesSelected && damageTypeSelected && itemTypeSelected;
    }

    public setConfirmed(): void {
        this.affectedItemsForm.controls.confirmed.setValue(true);
    }

    public handleSelectionChange(value: IOrderLine[]): void {
        this.affectedItemsForm.controls.confirmed.setValue(false);
        this.affectedItemsForm.get('affectedOrderLines')?.setValue(value);
    }

    private initItemTypeChangeListener(): void {
        this.form.controls.itemType.valueChanges
            .pipe(
                tap(value => {
                    this.affectedItemsForm.controls.typeValid.setValue(!!value);

                    if (
                        value === ItemType.REAGENT &&
                        this.form.controls.damageType.value === DamageIssueType.CONCEALED_INTERNAL_PACKAGING
                    ) {
                        this.showError = true;
                        return;
                    }

                    this.showError = false;
                })
            )
            .subscribe();
    }
}
